<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ods-dropdown-menu buttonSize="small" [buttonTooltip]="'Benutzermenü ' + currentUserName">
  <administration-user-menu-button button-content [currentUserInitials]="currentUserInitials"></administration-user-menu-button>

  <administration-user-logout-button (logout)="authenticationService.logout()"></administration-user-logout-button>

  @if (apiRootStateResource.resource | hasLink: ApiRootLinkRel.DOCUMENTATIONS) {
    <ods-dropdown-menu-link-item
      class="border-t"
      caption="Leitfaden für die Administration"
      text="PDF öffnen"
      [url]="apiRootStateResource.resource | getUrl: ApiRootLinkRel.DOCUMENTATIONS"
      data-test-id="administration-documentation"
    >
      <ods-file-icon icon fileType="pdf" size="medium" />
    </ods-dropdown-menu-link-item>
  }
</ods-dropdown-menu>
